import api from './axiosConfig';

// Interface for verification request payload
export interface VerificationRequest {
    request_id: string; // indigent number
    id_number: string;
    first_name: string;
    surname: string;
    address_line1: string;
    address_line2?: string; // optional
    postal_code: string;
}

// Interface for KYC data in verification response (snake_case from API)
export interface KYCData {
    consumer_id: string;
    first_name: string;
    second_name: string;
    surname: string;
    id_number: string;
    birth_date: string;
    gender: string;
    title_desc: string;
    marital_status_desc: string;
    age: number;
    privacy_status: string;
    residential_address: string | null;
    postal_address: string | null;
    home_telephone_no: string | null;
    work_telephone_no: string | null;
    cellular_no: string | null;
    email_address: string | null;
    employer_detail: string;
    reference_no: string;
    external_reference: string | null;
    nationality: string;
    // New KYC verification fields
    kyc_residential_address_confirmation: string | null;
    subscriber_enquiry_type: string;
    kyc_sources: string | null;
    subscriber_name: string;
    kyc_total_sources_used: number;
    subscriber_user_name: string;
    kyc_id_status_ind: number;
    subscriber_enquiry_input: string;
    kyc_status_ind: number;
    kyc_id_status_desc: string;
    kyc_enquiry_date: string;
    kyc_status_desc: string;
    kyc_id_validity: string;
    subscriber_enquiry_date: string;
}

// Interface for verification response
export interface VerificationResponse {
    message: string;
    success: boolean;
    request_id: string;
    kyc_data: KYCData;
}

export const verificationService = {
    // Check if KYC data already exists for this indigent
    checkExistingKyc: async (request_id: string): Promise<VerificationResponse | null> => {
        try {
            const response = await api.get<VerificationResponse>(`/verification/kyc/${request_id}`);

            // Check if the response indicates success
            if (response.data && response.data.success) {
                return response.data;
            }

            // If success is false or missing, return null
            return null;
        } catch (error: any) {
            // If 404 or no data found, return null
            if (error.response?.status === 404) {
                return null;
            }
            throw error;
        }
    },

    // Verify indigent details against external system
    verifyIndigent: async (data: VerificationRequest): Promise<VerificationResponse> => {
        try {
            const response = await api.post<VerificationResponse>('/verification/kyc', data);
            return response.data;

            // Mock response for now

            // // Simulate API delay
            // await new Promise(resolve => setTimeout(resolve, 1500));

            // // Return mock response
            // return {
            //     consumer_id: "133685946",
            //     first_name: "GROBLER",
            //     second_name: "",
            //     third_name: "",
            //     surname: "KRUGER",
            //     id_no: "800610xxxxxxx",
            //     passport_no: "",
            //     birth_date: "1980-06-10T00:00:00+02:00",
            //     gender_ind: "M",
            //     bonus_xml: "",
            //     temp_reference: "",
            //     enquiry_id: "56810226",
            //     enquiry_result_id: "58807473",
            //     reference: "C56810226-133685946"
            // };
        } catch (error) {
            throw error;
        }
    }
};
